import { createContext, useContext } from 'react';

export interface CardStripSlot {
    /** True in the strip's pinned `leading` slot, which has no card to its left to rule off from. */
    pinned: boolean;
}

/** Module-level so the provider's value keeps its identity across renders. */
export const PINNED_SLOT: CardStripSlot = { pinned: true };
export const SCROLLED_SLOT: CardStripSlot = { pinned: false };

/** Defaults to unpinned, so a card rendered outside a strip still draws its left rule. */
export const CardStripSlotContext = createContext<CardStripSlot>(SCROLLED_SLOT);

export const useCardStripSlot = (): CardStripSlot => useContext(CardStripSlotContext);
